export const convertMsToFrame = (
  milliseconds: number | undefined,
  side: 'start' | 'end' = 'start',
  fps = 30,
) => {
  if (
    typeof milliseconds !== 'number' ||
    !Number.isFinite(milliseconds) ||
    fps <= 0
  ) {
    return 0;
  }

  const seconds = milliseconds / 1000;

  if (side === 'end') {
    return Math.max(0, Math.ceil(seconds * fps));
  }

  const baseFrame = Math.floor(seconds * fps);
  const approximated = baseFrame / fps;

  if (approximated < seconds) {
    return baseFrame + 1;
  }

  return Math.max(baseFrame, 0);
};
